export default __webpack_public_path__ + "static/9-e2569250c760584ea8302ac22cf84a33.png";